import Vue from 'vue'
import Router from 'vue-router'

// views
import ahaAnalytics from '@/utils/aha-analytics/tracker'
import Home from './views/Home.vue'
import Presentation from './views/Presentation.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '',
      name: 'home',
      component: Home,
    },
    {
      path: '/:id',
      name: 'Presentation',
      component: Presentation,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const {
    name,
    fullPath,
  } = to

  const url = `${document.location.origin}${fullPath}`

  ahaAnalytics.setCustomUrl(url)
  ahaAnalytics.trackPageView({
    title: name,
    referrer: from.fullPath,
  })

  next()
})

export default router
